import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';
import {MposDate} from 'app/blocks/util/mpos-date';

export interface IProductTaxCategory extends IBaseEntity {
    id?: number;
    label?: string;
    isDefaultInGroup?: boolean;
    taxPercentage: number;
}

export class ProductTaxCategory extends BaseEntity implements IProductTaxCategory {
    public id?: number;
    public label?: string;
    public isDefaultInGroup?: boolean;
    public taxPercentage: number;

    constructor(productTaxCategory?) {
        super();
        if (productTaxCategory) {
            this.id = productTaxCategory.id;
            this.label = productTaxCategory.label;
            this.isDefaultInGroup = productTaxCategory.isDefaultInGroup;
            this.taxPercentage = productTaxCategory.taxPercentage;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): ProductTaxCategory {
        return new ProductTaxCategory(this);
    }
}
